letterAdjust.scale = 0.8;

var font = {
	"0": "M0 140l137 -140h334l137 140v786l-137 139h-334l-137 -139v-786zM184 185v695h240v-695h-240z",
	"1": "M0 0v185h103v695h-103v185h286v-880h101v-185h-387z",
	"2": "M0 0v488l137 138h287v254h-240v-113h-184v159l137 139h333l138 -139v-348l-138 -139h-286v-254h240v113h184v-298h-608z",
	"3": "M0 140v158h183v-113h240v254h-184v187h184v254h-240v-113h-183v159l137 139h332l137 -139v-322l-71 -72l71 -71v-321l-137 -140h-332z",
	"4": "M0 318h386v-133h-101v-185h388v185h-100v133h100v185h-100v562h-196l-377 -538v-209zM209 503l177 253v-253h-177z",
	"5": "M0 140v158h184v-113h239v273h-423v607h607v-185h-423v-237h285l138 -139v-364l-138 -140h-332z",
	"6": "M0 140l138 -140h333l137 140v348l-137 138h-287v254h240v-113h184v159l-137 139h-333l-138 -139v-786zM184 185v254h240v-254h-240z",
	"7": "M0 0v185h101l388 695h-247v-113h-184v298h656l-2 -154l-401 -726h76v-185h-387z",
	"8": "M0 140l137 -140h334l137 140v321l-72 71l72 72v322l-137 139h-334l-137 -139v-322l72 -72l-72 -71v-321zM184 185v254h240v-254h-240zM184 626v254h240v-254h-240z",
	"9": "M0 138l138 -138h333l137 138v788l-137 139h-333l-138 -139v-347l138 -138h286v-254h-240v113h-184v-162zM184 625v254h240v-254h-240z",
	"A": "M0 0h160l28 176h160l26 -176h160l-171 1065h-191zM213 332l55 335l54 -335h-109z",
	"B": "M0 0h402l132 133v329l-78 78l78 80v312l-132 133h-402v-1065zM159 159v303h219v-303h-219zM159 620v287h219v-287h-219z",
	"C": "M0 133l133 -133h266l135 133v199h-157v-173h-221v748h221v-143h157v168l-135 133h-266l-133 -133v-799z",
	"D": "M0 0h399l135 133v799l-135 133h-399v-1065zM156 159v748h221v-748h-221z",
	"E": "M0 0h534v159h-378v295h221v157h-221v296h378v158h-534v-1065z",
	"F": "M0 0h159v454h219v157h-219v296h375v158h-534v-1065z",
	"G": "M0 133l133 -133h269l132 133v357h-266v-158h109v-173h-221v748h221v-143h157v168l-132 133h-269l-133 -133v-799z",
	"H": "M0 0h156v454h222v-454h156v1065h-156v-454h-222v454h-156v-1065z",
	"I": "M0 0h159v1065h-159v-1065z",
	"J": "M0 133l133 -133h269l132 133v932h-157v-906h-221v173h-156v-199z",
	"K": "M0 0h159v445l25 43l182 -488h168l-248 658l248 407h-185l-190 -318v318h-159v-1065z",
	"L": "M0 0h418v159h-262v906h-156v-1065z",
	"M": "M0 0h156v620l112 -288l110 288v-620h156v1065l-156 -2l-110 -287l-112 289h-156v-1065z",
	"N": "M0 0h159v604l219 -604h156v1065h-156v-604l-219 604h-159v-1065z",
	"O": "M0 133l133 -133h269l132 133v799l-132 133h-269l-133 -133v-799zM159 159v748h218v-748h-218z",
	"P": "M0 0h159v404h243l132 132v396l-132 133h-402v-1065zM159 563v344h219v-344h-219z",
	"Q": "M0 131l132 -131h174l52 -98h133l-64 123l107 106v801l-132 133h-270l-132 -133v-801zM159 159v748h219v-748h-219z",
	"R": "M0 0h159v404h76l134 -404h165l-135 404l135 132v396l-132 133h-402v-1065zM159 563v344h219v-344h-219z",
	"S": "M0 133l135 -133h267l132 133v357l-132 130h-243v287h219v-143h156v168l-132 133h-267l-135 -133v-335l135 -135h243v-303h-219v173h-159v-199z",
	"T": "M0 907h188v-907h156v907h190v158h-534v-158z",
	"U": "M0 133l133 -133h269l132 133v932h-156v-906h-219v906h-159v-932z",
	"V": "M0 1065l172 -1065h189l173 1065h-160l-106 -667l-108 667h-160z",
	"W": "M0 1065l85 -1065h143l77 393l76 -393h142l85 1065h-158l-35 -429l-83 429h-55l-84 -429l-37 429h-156z",
	"X": "M0 0h168l100 290l98 -290h168l-182 532l182 533h-168l-98 -290l-100 290h-168l185 -533z",
	"Y": "M0 1065l188 -529v-536h155v536l188 529h-166l-100 -280l-97 280h-168z",
	"Z": "M0 177l51 -177h432l36 159h-353l365 729l-61 177h-421l-37 -158h353z"
};

  var font_size = 27,
      tracking = 2,
      panel_Hor_Adjustment = 2,
      font_Top_Adjustment = -22.5,
      small_Caps_Adjustment = {
        vertical: -215,
        horizontal: 0,
        scale_width: 0, // effects period
        scale_height: 0, // effects period
      },
      colors = {
        characters: {
          home: [
            "#FFFFFF", // white
            "#F47D30", // orange
          ],
          away: [
            "#1c3369", // blue
            "#F47D30", // orange
          ]
        },
        numbers: {
          home: [
            "#FFFFFF", // white
            "#F47D30", // orange
          ],
          away: [
            "#1c3369", // blue
            "#F47D30", // orange
          ]
        }
      },
      outlines = {
        characters: {
          width: 1.5
        },
        numbers: {
          width: 3
        }
      },
      special_Character_Adjustments = {
        period: {
          vertical: 8.5, // this moves it up from the bottom
          horizontal: 3,
          scale_width: 12.5,
          scale_height: 12.5,
        },
        hyphen: {
          vertical: -6,
          horizontal: -5.5,
          scale_width: 0,
          scale_height: -3,
        },
        apostrophe: {
          vertical: 0.25, // this is backwards
          horizontal: -1,
          scale_width: 0,
          scale_height: 0,
        }
      },
      number_Adjustments = {
        top: 13,
        left: -4.5,
        width: 110,
        height: 90,
        middle_Space: 5,
      };